function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-432.000000, -378.000000)",
  stroke: "#183E6B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(214.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(204.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  points: "0 0 9 10 18 0"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 18,
  height: 14
})))))));
var SvgIconEnvelope = function SvgIconEnvelope(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-envelope.1ecccea6.svg";
export { ForwardRef as ReactComponent };